import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const navClass = ({ isActive }) => `nav-link${isActive ? ' active' : ''}`;

function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [travelOpen, setTravelOpen] = useState(true); // open by default on desktop

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navigation">
      {/* Site title */}
      <div className="site-title" style={{ fontSize: '1.6rem', fontWeight: 700 }}>
        <div style={{ color: '#18d9bb', lineHeight: 1.1 }}>ERIK HOFFMAN</div>
        <div style={{ lineHeight: 1.1 }}>PHOTOS</div>
      </div>

      {/* Hamburger (mobile only) */}
      <div
        onClick={() => setMenuOpen((o) => !o)}
        className={`nav-toggler ${menuOpen ? 'open' : 'closed'}`}
        aria-label="Toggle navigation"
      >
        <span />
        <span />
        <span />
      </div>

      {/* Main menu */}
      <ul className={`nav-menu ${menuOpen ? 'nav-open' : ''}`} style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        <li>
          <NavLink to="/about" className={navClass} onClick={closeMenu}>About</NavLink>
        </li>
        <li>
          <NavLink to="/portraits" className={navClass} onClick={closeMenu}>People</NavLink>
        </li>
        <li>
          <NavLink to="/music" className={navClass} onClick={closeMenu}>Music</NavLink>
        </li>
        <li>
          <NavLink to="/weddings" className={navClass} onClick={closeMenu}>Weddings</NavLink>
        </li>

        {/* Travel — collapsible */}
        <li>
          <div
            className="nav-travel-toggle"
            onClick={() => setTravelOpen((o) => !o)}
            role="button"
            aria-expanded={travelOpen}
          >
            <span className="nav-travel-label">Travel</span>
            <span className={`nav-travel-chevron ${travelOpen ? 'open' : ''}`}>▼</span>
          </div>
          {travelOpen && (
            <ul className="sub-nav" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
              <li>
                <NavLink to="/africa" className={navClass} onClick={closeMenu}>Africa</NavLink>
              </li>
              <li>
                <NavLink to="/newyork" className={navClass} onClick={closeMenu}>New York</NavLink>
              </li>
            </ul>
          )}
        </li>

        <li>
          <NavLink to="/contact" className={navClass} onClick={closeMenu}>Contact</NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navigation;
